import { connect } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import View from "../view/view";
import { RootState } from "../../../app/store";
import { requestPasswortwechsel } from "../thunk/request_func";

interface OwnProps {
    /** Wird von withRouteParams eingehaengt. */
    history?: { push: (pfad: string) => void };
}

function mapStateToProps(state: RootState) {
    return {
        // 1 entspricht PasswordStatus.Auslieferung im Server.
        pflicht: state.LoginManager.model.pw_status === 1,
    };
}

function bindDispatchToActions(dispatch: Dispatch<any>, ownProps: OwnProps) {
    return {
        onSubmit: (altesPasswort: string, neuesPasswort: string) => {
            dispatch(requestPasswortwechsel(
                altesPasswort,
                neuesPasswort,
                ownProps.history ?? { push: () => { } },
            ) as any);
        },
    };
}

const Passwortwechsel = connect(mapStateToProps, bindDispatchToActions)(View);
export default Passwortwechsel;
